import apiClient from "../api/client";

const TAX_RATES_CACHE_TTL_MS = 60 * 60 * 1000;
let taxRatesCache = { data: null, timestamp: null, username: null };
let pendingTaxRatesFetch = null;

const getCachedTaxRates = (username) => {
  if (!taxRatesCache.data || !taxRatesCache.timestamp || taxRatesCache.username !== username) return null;
  if (Date.now() - taxRatesCache.timestamp >= TAX_RATES_CACHE_TTL_MS) {
    taxRatesCache = { data: null, timestamp: null, username: null };
    return null;
  }
  return taxRatesCache.data;
};

const setCachedTaxRates = (username, data) => {
  taxRatesCache = { data, timestamp: Date.now(), username };
};

export const fetchTaxRates = async (username) => {
  if (!username) return null;

  const cached = getCachedTaxRates(username);
  if (cached) return cached;

  if (pendingTaxRatesFetch) {
    try { return await pendingTaxRatesFetch; } catch { pendingTaxRatesFetch = null; }
  }

  pendingTaxRatesFetch = (async () => {
    try {
      const response = await apiClient.get('/api/v1/profile/tax-rates');
      if (response.data) {
        const longTerm = response.data.totalLongTermTaxRate ?? response.data.LONG_TERM ?? 20;
        const shortTerm = response.data.totalShortTermTaxRate ?? response.data.SHORT_TERM ?? 30;
        const result = {
          LONG_TERM: Number(Number(longTerm).toFixed(2)),
          SHORT_TERM: Number(Number(shortTerm).toFixed(2)),
        };
        setCachedTaxRates(username, result);
        return result;
      }
      return null;
    } catch (err) {
      console.error("Error fetching tax rates:", err.response?.data || err);
      throw err;
    } finally {
      pendingTaxRatesFetch = null;
    }
  })();

  try { return await pendingTaxRatesFetch; } catch { return null; }
};

export const invalidateTaxRatesCache = () => {
  taxRatesCache = { data: null, timestamp: null, username: null };
};
